import {Sidebar} from "primereact/sidebar";

export default function DialogPanel ({visible, toggle, children, height = '80vh'}) {
  return (
    <Sidebar visible={visible} position="bottom" style={{height: height}} onHide={toggle}>
      { children }
    </Sidebar>
  )
}